// Spinner component

//MUI components
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const BackdropSpinner = ({
  open,
  size = 40,
  color = "primary",
}: {
  open: boolean;
  size?: number;
  color?:
    | "inherit"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning";
}) => {
  return (
    <Backdrop
      sx={{ color: color, zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}>
      <CircularProgress size={size} color={color} />
    </Backdrop>
  );
};

export default BackdropSpinner;
